import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BehaviorSubject, tap, take, exhaustMap, Observable, map} from "rxjs";
import {LoaderService} from "./loader.service";
import {AuthenticationService} from "./authentication.service";
import {
  ActionResult,
  ActionResultList, DEFAULT_PAGE_SIZE, EventItem,
  EventItemType,
  EventRaceItem,
  FetchEventByIdRequest, FetchRaceByIdRequest,
  FindEventsRequest,
  FindRacesRequest,
  ItemType
} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class EventRaceService {
  private static _eventRaces: BehaviorSubject<ActionResultList<EventRaceItem[], number> | null> = new BehaviorSubject<ActionResultList<EventRaceItem[], number> | null>(null);
  private static _favoriteEventRaces: BehaviorSubject<ActionResultList<EventRaceItem[], number> | null> = new BehaviorSubject<ActionResultList<EventRaceItem[], number> | null>(null);
  private static _hasMoreEventRace: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  get eventRaces(): BehaviorSubject<ActionResultList<EventRaceItem[], number> | null> {
    return EventRaceService._eventRaces;
  }

  get favoriteEventRaces(): BehaviorSubject<ActionResultList<EventRaceItem[], number> | null> {
    return EventRaceService._favoriteEventRaces;
  }

  get hasMoreEventRace(): BehaviorSubject<boolean> {
    return EventRaceService._hasMoreEventRace;
  }

  constructor(private http: HttpClient, private loaderService: LoaderService, private authService: AuthenticationService, private environmentService:EnvironmentService) {
  }

  emptyEventRaces() {
    this.eventRaces.next(null);
    this.hasMoreEventRace.next(false);
    this.favoriteEventRaces.next(null)
  }

  findEventRacesPaged(itemType: ItemType, eventItemType: EventItemType, page: number, onSuccess: () => void, onError: () => void) {
    switch (itemType) {
      case ItemType.EVENT:
        this.loaderService.startLoading();
        this.http.post<ActionResultList<EventRaceItem[], number>>(this.environmentService.getApiUrl() + "/api/public/events/filter", FindEventsRequest.createEventRacePagedFilter(page, eventItemType))
          .pipe((
            tap(() => this.loaderService.dismissLoading())))
          .subscribe((actionResultList: ActionResultList<EventRaceItem[], number>) => {
            this.handleResponse(actionResultList);
          });
        break;

      case ItemType.RACE:
        this.loaderService.startLoading();
        this.authService.jwtResponse.pipe(take(1), exhaustMap(() => {
            return this.http.post<ActionResultList<EventRaceItem[], number>>(this.environmentService.getApiUrl() + "/api/races/userallraces", FindRacesRequest.createLandingRacesPagedFilterRequest(page, eventItemType));
          }),
          tap(() => this.loaderService.dismissLoading())).subscribe((actionResultList: ActionResultList<EventRaceItem[], number>) => {
          this.handleResponse(actionResultList);
        });
        break;
    }
  }

  findEventRaceById(eventRaceItem: EventRaceItem|undefined) {
    if(eventRaceItem){
      if (eventRaceItem.type === "E") {
        return this.http.post<ActionResult<EventItem>>(this.environmentService.getApiUrl() + "/api/public/events/geteventbyid", new FetchEventByIdRequest(eventRaceItem?.id))
      } else {
        return this.http.post<ActionResult<EventItem>>(this.environmentService.getApiUrl() + "/api/public/races/getracebyid", new FetchRaceByIdRequest(eventRaceItem?.id))
      }
    }else{
      return eventRaceItem;
    }
  }

  addEventToFavorites(eventId: number, isRace?: boolean): Observable<ActionResult<boolean>> {
    let endpoint: string = isRace === true ? "/api/races/favorite/add" : "/api/events/favorite/add"
    return this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + endpoint, eventId)

  }

  removeEventFromFavorites(eventId: number, isRace?: boolean): Observable<ActionResult<boolean>> {
    let endpoint: string = isRace ? "/api/races/favorite/remove" : "/api/events/favorite/remove"
    return this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + endpoint, eventId);
  }

  fetchUserFavoritesEventRaces(startLoading?: boolean): Observable<EventRaceItem[]> {
    return this.http.get<ActionResultList<(EventRaceItem)[], number>>(this.environmentService.getApiUrl() + "/api/events/favorite/eventRaces").pipe(map((value: ActionResultList<EventRaceItem[], number>) => {
        if (value && value.result && value.result.length !==0) {
          this.favoriteEventRaces.next(value);
          return value.result;
        } else {
          this.favoriteEventRaces.next(null);
          return [];
        }
      })
    );
  }

  // fetchUserFavoritesEventRaces(startLoading?: boolean) {
  //   if (startLoading) {
  //     this.loaderService.startLoading();
  //   }
  //   this.http.get<ActionResultList<(EventRaceItem)[], number>>(
  //     this.environmentService.getApiUrl() + "/api/events/favorite/eventRaces"
  //   ).pipe((
  //     tap(() => {
  //       if (startLoading) {
  //         this.loaderService.dismissLoading()
  //       }
  //     }))).subscribe((actionResut: ActionResultList<(EventRaceItem)[], number>) => {
  //     this.favoriteEventRaces.next(actionResut);
  //   })
  // }

  private handleResponse(actionResultList: ActionResultList<EventRaceItem[], number>) {
    if (actionResultList.result) {
      if (actionResultList.result?.length > DEFAULT_PAGE_SIZE) {
        this.hasMoreEventRace.next(true);
        actionResultList.result = (actionResultList.result!.slice(0, DEFAULT_PAGE_SIZE))
      } else {
        this.hasMoreEventRace.next(false);
      }
      if (this.eventRaces.getValue()?.result) {
        actionResultList.result = this.eventRaces.getValue()?.result?.concat(actionResultList.result)
      }
    }
    this.eventRaces.next(actionResultList);
  }
}

